import axios from 'axios'
import store from './../store';

export default class BTCTransactionsService {


    async getAllTransactions() {
        try {
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/btctransactions',
                headers: {
                    authorization: store.state.currentUser.token
                }
            });

            return res;

        } catch (error) {
            throw new error
        }

        
    }


}